<section
  class="contact"
  id="contact"
  (mousemove)="onMouseMove($event)"
>
  <div class="contact-spotlight" [style.background]="spotlightGradient"></div>

<div class="contact-content">
    <p class="contact-eyebrow reveal">Begin Your Journey</p>
    <h2 class="contact-title reveal reveal-delay-1">
      Reserve Your Unit Today
    </h2>
    <p class="contact-sub reveal reveal-delay-2">
      Step into an exclusive world crafted for the discerning few. Register your interest and our team will guide you through every detail of life at ACACIA.
    </p>

    <form class="contact-form reveal reveal-delay-2" (ngSubmit)="onSubmit()" #contactForm="ngForm">
      <input type="text" class="full" placeholder="Full Name" name="name" [(ngModel)]="form.name" required />
      <input type="email" class="full" placeholder="Email Address" name="email" [(ngModel)]="form.email" required />
      <input type="tel" class="full" placeholder="Phone Number" name="phoneNumber" [(ngModel)]="form.phoneNumber" />
      <input type="text" class="full" placeholder="Company (optional)" name="company" [(ngModel)]="form.company" />
      <select class="full" name="unitType" [(ngModel)]="form.unitType">
        <option value="" disabled selected>Unit of Interest</option>
        <option value="1bed">1 Bedroom</option>
        <option value="2bed">2 Bedroom</option>
      </select>
      <textarea class="full" placeholder="Message or specific requirements..." name="message" [(ngModel)]="form.message"></textarea>
      <button type="submit" class="contact-submit">Reserve Your Unit Today</button>
    </form>

    <p class="contact-email reveal reveal-delay-3">
      Or reach us directly at <a href="mailto:sales@acacia.ke">sales&#64;acacia.ke</a>
    </p>
  </div>
</section>
